import { Parameters } from "../interfaces/parameters";

const normalize = (fields: Parameters): Record<string, unknown> => {
  let grouping: Record<string, unknown>[] | null = null;

  if (fields.grouping) {
    grouping = Object.entries(fields.grouping).reduce(
      (result, [key, value]) => {
        if (value === null) {
          return { ...result };
        }

        if (value.length > 0) {
          return { ...result, [key]: value[0] };
        }

        return { ...result };
      },
      [] as Record<string, unknown>[]
    );
  }

  return {
    ...fields,
    end_date: fields.end_date ? fields.end_date.format("YYYY-MM-DD") : null,
    start_date: fields.start_date
      ? fields.start_date.format("YYYY-MM-DD")
      : null,

    grouping,
  };
};

export default normalize;
